import React from 'react';
import PropTypes from 'prop-types';

import { Row, Col, PageHeader } from 'antd';
import OnTraccrCheckbox from '../common/inputs/OnTraccrCheckbox';
import Colors from '../constants/Colors';

export default function ProjectColumnChangerContent({
  selectedSet,
  onChange,
  baseOptions,
  bucketOptions,
}) {
  return (
    <div style={{ width: 175 }}>
      <Row>
        <PageHeader
          title='Columns'
          style={{ padding: 0, marginBottom: 5, fontFamily: 'raleway-medium' }}
        />
      </Row>
      <Col>
        {baseOptions.map(({ label, value }) => (
          <Row key={value}>
            <OnTraccrCheckbox
              onChange={onChange(value)}
              value={selectedSet.has(value)}
              label={label}
            />
          </Row>
        ))}
        {bucketOptions.length > 0 && (
          <>
            <Row style={{
              marginTop: 12,
              marginBottom: 4,
              fontSize: 18,
              color: Colors.REDESIGN_SECONDARY_TEXT,
              fontFamily: 'raleway-medium',
            }}>
              Buckets
            </Row>
            {bucketOptions.map(({ label, value }) => (
              <Row key={value}>
                <OnTraccrCheckbox
                  onChange={onChange(value)}
                  value={selectedSet.has(value)}
                  label={label}
                />
              </Row>
            ))}
          </>
        )}
      </Col>
    </div>
  );
}

ProjectColumnChangerContent.propTypes = {
  selectedSet: PropTypes.instanceOf(Set).isRequired,
  onChange: PropTypes.func.isRequired,
  baseOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  bucketOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
};